import clsx from "clsx";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { InfoCircle } from "@/assets/icons/ds";
import { HintTooltip } from "@/components/Interface/HintTooltip/HintTooltip";

interface TarifBarHeadlineProps {
  className?: string;
  title?: string;
  tooltipContent?: ReactNode;
}

/** The headline row of a tarif-bar usage card: title + optional inline info-tooltip trigger. */
export const TarifBarHeadline = ({
  className,
  title,
  tooltipContent,
}: TarifBarHeadlineProps) => {
  const { t } = useTranslation("portal");

  if (!title) {
    return null;
  }

  return (
    <div className={clsx("flex w-full items-center gap-2.5", className)}>
      <p className="flex-1 text-body-base font-semibold leading-none text-foreground-primary">
        {title}
      </p>
      {tooltipContent && (
        <HintTooltip align="right" content={tooltipContent}>
          <button
            data-testid="tarif-bar-headline-tooltip-trigger"
            className="flex shrink-0"
            type="button"
            aria-label={t("common.tooltip.moreInfo")}
          >
            <InfoCircle className="size-4 text-foreground-primary" />
          </button>
        </HintTooltip>
      )}
    </div>
  );
};
